export default __webpack_public_path__ + "static/media/CoronaOpen.2d9cb11e.jpg";